var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fox",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "-806.366 -35.79 2414.703 2628.606",
    width: 3219.604,
    height: 3504.808,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-806.366-35.79h2414.703v2628.606H-806.366z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body",
    d: "M-353.037 1850.344c-156.127 166.092-225.876 372.056-209.276 617.863l1803.762-.047c46.077-172.34-59.793-518.161-249.138-577.954l-1345.348-39.862z",
    fill: "#E67A3B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5D5D5D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "paws",
    d: "M916.768 2304.391c-89.764-142.194-221.428-49.206-262.433 57.407-41.005 106.613.041 237.986 61.134 195.881 17.577 48.141 112.706 42.459 132.53-3.355 47.866 45.4 158.532-107.74 68.769-249.933zM-232.168 2304.106c89.764-142.194 221.427-49.206 262.432 57.407 41.006 106.613-.04 237.986-61.133 195.881-17.577 48.141-112.706 42.46-132.53-3.355-47.866 45.4-158.532-107.74-68.769-249.933z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-ear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right-ear-inside",
    d: "M669.05 575.558c159.513-332.027 490.639-540.426 923.231-590.166 72.119 488.972-105.116 886.321-403.183 1098.527-107.473-212.866-261.335-401.787-520.048-508.361z",
    fill: "#AE4F17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-ear-outside",
    d: "M660.285 574.097C819.798 242.07 1150.924 33.671 1583.516-16.069c-256.63 255.15-620.141 369.113-589.45 815.131-105.178-122.708-233.729-181.14-333.781-224.965z",
    fill: "#E67A3B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-ear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-ear-inside",
    d: "M140.914 555.837C-18.598 223.81-349.725 15.411-782.316-34.329c-72.12 488.972 105.115 886.322 403.183 1098.528 107.472-212.867 261.334-401.788 520.047-508.362z",
    fill: "#AE4F17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-ear-outside",
    d: "M149.679 554.377C-9.834 222.349-340.96 13.95-773.551-35.79c256.629 255.15 620.14 369.113 589.449 815.131 105.179-122.708 233.73-181.14 333.781-224.964z",
    fill: "#E67A3B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-806.366 1779.264c295.978 63.266 706.766 259.281 1147.14 545.917 20.387 13.27 55.438 17.243 92.938 3.442 267.046-198.32 596.501-375.683 1114.744-414.965C1377.349 1027.183 870.641 517.126 385.653 517.126c-484.988 0-895.348 335.446-1192.019 1262.138z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-657.364 1376.081C94.477 882.552 354.53 1229.28 373.967 2100.642c55.652-749.104 278.689-1202.909 1002.114-742.091C1143.155 714.675 683.658 505.44 365.202 505.44c-370.757 0-853.946 308.494-1022.566 870.641z",
    fill: "#E67A3B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-eye"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 57.239,
    cy: 1844.44,
    r: 189.25,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-pupil"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 58.755,
    cy: 1846.592,
    r: 101.077,
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: -10.538,
    cy: 1807.462,
    r: 38.538,
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right-eye"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 689.72,
    cy: 1856.214,
    r: 189.25,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-pupil"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 691.236,
    cy: 1858.366,
    r: 101.077,
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 616,
    cy: 1818,
    r: 38.538,
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    d: "M175.166 2205.509c120.76-46.37 274.33-38.808 410.662 1.371-78.002 57.876-127.695 95.08-162.483 112.435-6.752 3.369-61.375 1.783-66.501 4.114-58.4-47.629-124.09-71.3-181.678-117.92z",
    fill: "#5D5D5D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.e5da84e4.svg";
export { ForwardRef as ReactComponent };